import React, { useState, useRef, useEffect } from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import placeHolderImg from "../../Assets/Images/placeholder.png";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import img1 from "../../Assets/Images/static/story1.jpg";
const ShopifyProductsPreview = ({
  list,
  updateOpenArrayState,
  sectionId,
  title,
}) => {
  const spanStyle = {
    padding: "10px",
    background: "#efefef",
    color: "#000000",
    width: "50%",
    textAlign: "center",
  };
  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    height: "160px",
    borderRadius: "7px",
    border: "1px solid #e6e7e8",
    marginRight: "0.4rem",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="mt-3 containerPreviewRichText">
      <div className="slide-container">
        <Slide slidesToShow={2} duration={2000000} arrows={false}>
          {list.map((slideImage, index) => (
            <div key={index} arrows={false}>
              <div
                className="mb-2"
                style={{
                  ...divStyle,
                  backgroundImage: `url(${
                    slideImage.product_details?.image?.src
                      ? slideImage.product_details?.image?.src
                      : ""
                  })`,
                }}
              ></div>
              <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                {slideImage.product_details?.title
                  ? slideImage.product_details?.title
                  : ""}
              </p>
            </div>
          ))}
        </Slide>
      </div>
      {/* <div className="slide-container mx-1">
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <b style={{ color: "#101010", fontsize: 16 + "px" }}>
              {title.toUpperCase()}
            </b>
          </div>
        </div>
        <Slide
          transitionDuration={200}
          duration={100000}
          arrows={false}
          slidesToShow={2}
        >
          <div className="d-flex mt-2">
            {map((slideImage, index) => (
              <div className="mx-1 w-50" key={index}>
                <div className="border-grey">
                  <img
                    className="d-inline-flex"
                    style={{
                      width: "100" + "%",
                      height: 165 + "px",

                      backgroundImage: `url(${
                        slideImage.images[0]?.src
                          ? slideImage.images[0].src
                          : placeHolderImg
                      })`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    alt=""
                  />
                </div>
                <p style={{ color: "#101010", fontsize: 13 + "px" }}>
                  {slideImage.title ? slideImage.title : ""}
                </p>
              </div>
            ))}
          </div>
        </Slide>
      </div> */}

      <div className="overlay4" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default ShopifyProductsPreview;
